// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import LabLockIcon from '../../../assets/images/lab-icon-lock.svg';
import { getColor } from '../../../styled/color';

interface Step {
  title: string;
  isLock: boolean;
}

export const NAVIGATION_TOP_OFFSET = -100;

function getMarkdownTitle(markdown: string): string {
  return markdown.split('\n')[0].trim().replace(/^#+\s+/, '')
}

interface NavigationProps extends ComponentPropsWithRef<'ul'> {
  markdowns: string[];
  isMarkdownShow: boolean;
  currentIndex: number;
  onNavigate: (step: number) => void;
}

const Navigation = (props:NavigationProps): JSX.Element => {
  const {
    markdowns,
    isMarkdownShow,
    currentIndex,
    onNavigate,
    ...otherProps
  } = props;

  const intl = useIntl();
  const overviewTitle = intl.formatMessage({ id: 'E027' });

  const steps = useMemo(() => {
    const markdownSteps = isMarkdownShow ?
      markdowns.map((markdown) => ({
        title: getMarkdownTitle(markdown),
        isLock: false
      })) :
      [
        { title: '', isLock: true },
        { title: '', isLock: true },
        { title: '', isLock: true },
        { title: '', isLock: true },
      ]

    return [
      {
        title: overviewTitle,
        isLock: false,
      },
      ...markdownSteps
    ];
  }, [markdowns, isMarkdownShow, overviewTitle]);

  const handleNavigation = (step:Step, index:number) => {
    if (!step.isLock) {
      onNavigate(index);
    }
  }

  return (
    <ul {...otherProps}>
      {steps.map((step, index) => (
        <Link
          as="li"
          to={`m-${index}`}
          key={index}
          smooth={true}
          offset={NAVIGATION_TOP_OFFSET + 1} // fix react-scroll bug
          className={step.isLock ? 'row item lock' : 'row item' + (currentIndex === index ? ' active' : '')}
          onClick={() => handleNavigation(step, index)}
        >
          <div className="a column">
            <div className="line"></div>
            <div className="circle">{index + 1}</div>
            <div className="line"></div>
          </div>
          <p className={step.isLock ? 'lock' : ''}>{step.title}</p>
        </Link>
      ))}
    </ul>
  )
}

const S = styled(Navigation)`
  * {
    transition: all 0.5s;
  }

  .row {
    display: flex;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .circle {
    width: 30px;
    height: 30px;
    border: 2px solid #C9C9C9;
    border-radius: 100%;
    font-weight: 700;
    font-size: 14px;
    color: #666666;
    line-height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .item {
    align-items: stretch;

    &:not(.lock) {
      &.active, &:hover {
        .circle {
          width: 45px;
          height: 45px;
          font-size: 20px;
          color: ${getColor('Orange')};
          border-color: ${getColor('Orange')};
        }
      }

      &:hover {
        p {
          color: ${getColor('Orange')};
        }
      }
    }
  }

  .item.active .line:last-child, .item:hover:not(.lock)  .line:last-child,
  .item.active +.item .line:first-child, .item:hover:not(.lock) + .item  .line:first-child {
    background-color: ${getColor('Orange')};
  }

  .item:first-child .line:first-child {
    opacity: 0;
  }

  .item:last-child .line:last-child {
    opacity: 0;
  }

  .item.active p {
    color: #666666;
  }

  .line {
    flex: 1;
    width: 1px;
    background: #c9c9c9;
  }

  .a {
    flex-shrink: 0;
    align-items: center;
    width: 45px;
    margin-right: 10px;
  }

  p {
    color: #848484;
    margin: 0;
    min-height: 60px;
    display: flex;
    align-items: center;
    font: 14px Noto Sans TC;
    cursor: pointer;
    overflow-wrap: break-word;
    width: 100%;
  }

  p.lock {
    cursor: default;
  }

  .item.lock .circle {
    color: transparent;
    background-image: url(${LabLockIcon});
    background-position: center;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    cursor: default;
  }
`;

export default S;
